module.exports = {
    title: "Response Response List",
    crud: {
        create: "Create Response",
        edit: "Edit Response",
        view: "View Response",
    },
    table: {
        response: "Response",
        priority: "Priority",
        username: "Response By",
        description: "Description",
        traveller: "Traveller",
        user: "Traveller",
        sender: 'Sender',
    },
    form: {
        priority: "Priority",
        user: "Traveller",
        sender: 'Sender',
        traveller: "Traveller",
        response: "Response Message",
        isActive: "isActive",
        description: "Description",
    },
    validation: {
        required: {
            reason: 'Reason is required',
        },

    },
}
